'use client';

import { AlertTriangle } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

interface InappropriateLanguageBannerProps {
  testIdPrefix?: string;
}

/**
 * Inline warning shown beneath a composer while inappropriate language is
 * present (MWBI-866). Render it conditionally on the caller's `hasInappropriate`
 * flag. Copy comes from the `crisis` i18n namespace (EN/ES).
 */
export function InappropriateLanguageBanner({
  testIdPrefix = 'inappropriate-language-banner',
}: InappropriateLanguageBannerProps) {
  const { t } = useLanguage();

  return (
    <div
      role="alert"
      className="flex items-center gap-2 px-3 py-2 bg-yellow-50 border border-yellow-300 rounded-lg"
      data-testid={`${testIdPrefix}-warning`}
    >
      <AlertTriangle className="text-yellow-600 shrink-0" size={16} aria-hidden="true" />
      <p className="text-xs text-yellow-800">{t.crisis.inappropriateBannerWarning}</p>
    </div>
  );
}
